<template>
  <pt-waiting-sample-recollect class="pt-waiting-sample-recollect__page"></pt-waiting-sample-recollect>
</template>

<script>
import PtWaitingSampleRecollect from 'cps/goods-order/pt-waiting-sample-recollect/withData'
export default {
  name: 'pt-waiting-sample-recollect__view',
  components: {
    'pt-waiting-sample-recollect': PtWaitingSampleRecollect
  }
}
</script>
